import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_bath_towels: FaireCategoryEntity = {
  token: "cat_bath-towels",
  type: "category",
  name: "Towels",
  level: 3,
  parentToken: "cat_home-decor-bath",
  href: "/category/home-decor/bath/towels",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
